const initialState = {
  uploadingFile: false,
  searching: false,
  autocompleteOptions: null,
};

export default initialState;
